module.exports = __webpack_public_path__ + "static/media/dobleR.9867ff52.svg";